<template>
  <div class="block" style="padding: 0 10%;">
    <div class="container">
      <section class="section mt-6">
        <div class="columns is-desktop has-text-primary">
          <div class="column">
            <img alt="Team" src="../../assets/teams/ebere.png" />
          </div>
          <div class="column is-three-fifths ml-5 pl-5">
            <h3 class="is-size-3 bold-text mt-3 pt-5"><b>Ebere Wisdom Onyemsoadighinfe</b></h3>
            <p class="regular-text has-text-primary mt-5">
              Ebere Wisdom Onyemsoadighinfe is a graduate of Michael Okpara University of Agriculture Umudike, Abia State where he obtained his B.Eng in Computer engineering. He is also a certified system analyst and specializes in hardware and software maintenance.
            </p>
            <p class="regular-text has-text-primary mt-3">
              Wisdom is currently the IT/ICT Resource manager and Researcher at Legal Jurisprudence Limited, publishers of Erudite Judgments of the Supreme Court.
            </p>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "TeamInfo",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @font-face {
    font-family: "MontBold";
    src: url("../../fonts/Mont/Mont-Bold.otf");
  }

  @font-face {
    font-family: "MontRegular";
    src: url("../../fonts/Mont/Mont-Regular.otf");
  }

  .bold-text {
    font-family: "MontBold";
  }

  .regular-text {
    font-family: "MontRegular";
  }
</style>
